import { gql } from 'apollo-boost';

import { freelancerFeedbackFragment } from '../../queries/public-grid/freelancers';

export const requestFlServiceByClient = gql`
    mutation RequestFlServiceByClientMutation($input: GdRequestFlServiceByClientRequestInput!) {
        reqId: getReqId
        requestFlServiceByClient(input: $input) {
            freelancerId
            clientId
            freelancerProject {
                id
                startedTime
                createdTime
                freelancer {
                    login
                }
            }
        }
    }
`;

export const acceptFlServiceByFreelancer = gql`
    mutation AcceptFIServiceByFreelancerMutation($input: GdAcceptFlServiceByFreelancerRequestInput!) {
        reqId: getReqId
        acceptFlServiceByFreelancer(input: $input) {
            freelancerProject {
                id
                updatedTime
            }
        }
    }
`;

export const cancelFlServiceByFreelancer = gql`
    mutation CancelFIServiceByFreelancerMutation($input: GdCancelFlServiceByFreelancerRequestInput!) {
        reqId: getReqId
        cancelFlServiceByFreelancer(input: $input) {
            freelancerProject {
                id
                updatedTime
            }
        }
    }
`;

export const cancelFlServiceByClient = gql`
    mutation CancelFlServiceByClientMutation($input: GdCancelFlServiceByClientRequestInput!) {
        reqId: getReqId
        cancelFlServiceByClient(input: $input) {
            freelancerId
            clientId
            freelancerProject {
                id
                status
            }
        }
    }
`;

export const updateFreelancerStatus = gql`
    mutation UpdateFreelancerStatusMutation($input: GdUpdateFlStatusRequestInput!) {
        reqId: getReqId
        updateFreelancerStatus(input: $input) {
            freelancer {
                status
            }
        }
    }
`;

export const addFeedbackForFreelancer = gql`
    mutation AddFeedbackForFreelancerMutation($input: GdAddFeedbackForFreelancerRequestInput!) {
        reqId: getReqId
        addFeedbackForFreelancer(input: $input) {
            feedback {
                ...FreelancerFeedbackQueryFragment
            }
        }
    }
    ${freelancerFeedbackFragment}
`;

export const updateFreelancerFeedback = gql`
    mutation UpdateFreelancerFeedbackMutation($input: GdUpdateFreelancerFeedbackRequestInput!) {
        reqId: getReqId
        updateFreelancerFeedback(input: $input) {
            feedback {
                ...FreelancerFeedbackQueryFragment
            }
        }
    }
    ${freelancerFeedbackFragment}
`;

export const deleteFreelancerFeedback = gql`
    mutation DeleteFreelancerFeedbackMutation($input: GdDeleteFreelancerFeedbackRequestInput!) {
        reqId: getReqId
        deleteFreelancerFeedback(input: $input) {
            feedbackId
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    code
                    params
                    path
                }
            }
        }
    }
`;

export const updateUserPhone = gql`
    mutation UpdateUserPhoneMutation($input: GdUpdateUserPhoneInput!) {
        updateUserPhone(input: $input) {
            user {
                phone
            }
        }
    }
`;

export const updateFreelancerCardData = gql`
    mutation UpdateFreelancerCardMutation(
        $commonInput: GdUpdateFreelancerCardInput!
        $skillsInput: GdUpdateFreelancerSkillInput!
        $regionInput: GdUpdateFreelancerInput!
    ) {
        reqId: getReqId
        updateFreelancerCard(input: $commonInput) {
            validationResult {
                errors {
                    code
                }
            }
        }
        updateFreelancerSkills(input: $skillsInput) {
            validationResult {
                errors {
                    code
                }
            }
        }
        updateFreelancer(input: $regionInput) {
            validationResult {
                errors {
                    code
                }
            }
        }
    }
`;
